import { render, staticRenderFns } from "./BizBusinessinfoForm.vue?vue&type=template&id=27c376fd&"
import script from "./BizBusinessinfoForm.vue?vue&type=script&lang=js&"
export * from "./BizBusinessinfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports